<template>
  <li>
    <hr v-if="separateTop" class="separate" />

    <router-link
      v-if="isLink"
      :class="['menu-item', { 'menu-item--danger': danger }]"
      :to="routerLinkTo"
    >
      <div class="menu-item__icon">
        <slot name="icon" />
      </div>
      <div class="menu-item__text">
        <slot name="label" />
      </div>
    </router-link>

    <button
      v-else
      :class="['menu-item', { 'menu-item--danger': danger }]"
      @click="click"
    >
      <div class="menu-item__icon">
        <slot name="icon" />
      </div>
      <div class="menu-item__text">
        <slot name="label" />
      </div>
    </button>
  </li>
</template>

<script>
export default {
  props: {
    routerLinkTo: {
      type: Object,
      required: false,
      default: () => {},
    },
    danger: {
      type: Boolean,
      required: false,
      default: false,
    },
    separateTop: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    isLink() {
      return this.routerLinkTo
    },
  },
  methods: {
    click() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
.separate {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid $color-border;
  margin: 4px 0;
  padding: 0;
}
.menu-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: $spacing-3xs;
  width: 100%;
  padding: $spacing-4xs $spacing-3xs;
  border: 1px solid transparent;
  background: none;
  color: $color-text;
  transition: transform 200ms ease-in-out;
  cursor: pointer;

  &:hover {
    color: $color-canvas;
    background: $color-navigation;
    border-radius: $border-radius-xs;
    border: 1px solid transparent;
  }

  &--danger {
    color: $color-red-50;

    &:hover {
      color: $color-canvas;
      background: $color-red-50;
    }
  }

  &:active {
    transform: scale(0.95);
    transition: transform 100ms ease-in-out;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;

    :deep(svg, img) {
      display: flex;
      justify-content: center;
      align-items: center;
      object-fit: cover;
      width: inherit;
      height: inherit;
    }
  }

  &__text {
    font-weight: 400;
    text-align: left;
    font-size: $font-size-s;
    line-height: 1;
  }
}
</style>
